var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseModalForm', {
    attrs: {
      "headline": _vm.headline,
      "modalType": _vm.type,
      "editable": ""
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      },
      "submit": _vm.onSubmit
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": "",
      "disabled": _vm.isCourseClosed
    }
  }, [_vm.canEditName ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('PersonSearchInput', {
    attrs: {
      "label": "Legg til ".concat(_vm.isVocationalSchool ? 'student' : 'deltaker'),
      "filterIsActive": ""
    },
    model: {
      value: _vm.applicantData.userId,
      callback: function callback($$v) {
        _vm.$set(_vm.applicantData, "userId", $$v);
      },
      expression: "applicantData.userId"
    }
  })], 1)], 1) : _vm._e(), _c('v-row', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.isDisabled ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('TheMemberOrganizaionModalTreeHierarchy', {
          attrs: {
            "buttonLabel": "Velg medlemsorganisasjon",
            "memberOrgHierarchi": _vm.hierarchicalMemberOrgs,
            "disabled": _vm.hierarchyLoading || _vm.isDisabled
          },
          on: {
            "update": _vm.setMemberOrg
          }
        })], 1)];
      }
    }], null, false, 4114030022)
  }, [_c('span', [_vm._v(_vm._s(_vm.disabledEditTooltip))])]) : _c('TheMemberOrganizaionModalTreeHierarchy', {
    attrs: {
      "buttonLabel": "Velg medlemsorganisasjon",
      "memberOrgHierarchi": _vm.hierarchicalMemberOrgs,
      "disabled": _vm.hierarchyLoading
    },
    on: {
      "update": _vm.setMemberOrg
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Valgt medlemsorganisasjon",
      "readonly": "",
      "rules": _vm.validateNotEmpty,
      "loading": _vm.hierarchyLoading
    },
    model: {
      value: _vm.selectedMemberOrgName,
      callback: function callback($$v) {
        _vm.selectedMemberOrgName = $$v;
      },
      expression: "selectedMemberOrgName"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.isDisabled ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
            attrs = _ref2.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-select', {
          attrs: {
            "disabled": _vm.isDisabled,
            "label": "Status",
            "items": _vm.courseParticipantStatuses,
            "item-text": "text",
            "item-value": "value",
            "rules": _vm.validateNotEmpty,
            "loading": _vm.statusLoading,
            "data-cy": "editParticipantStatus"
          },
          model: {
            value: _vm.applicantData.status,
            callback: function callback($$v) {
              _vm.$set(_vm.applicantData, "status", $$v);
            },
            expression: "applicantData.status"
          }
        })], 1)];
      }
    }], null, false, 516560161)
  }, [_c('span', [_vm._v(_vm._s(_vm.disabledStatusTooltip))])]) : _vm._e(), !_vm.isDisabled ? _c('v-select', {
    attrs: {
      "disabled": _vm.isDisabled,
      "label": "Status",
      "items": _vm.courseParticipantStatuses,
      "item-text": "text",
      "item-value": "value",
      "rules": _vm.validateNotEmpty,
      "loading": _vm.statusLoading,
      "data-cy": "editParticipantStatus"
    },
    model: {
      value: _vm.applicantData.status,
      callback: function callback($$v) {
        _vm.$set(_vm.applicantData, "status", $$v);
      },
      expression: "applicantData.status"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.isDisabled ? _c('v-text-field', {
    attrs: {
      "value": _vm.lockedSectorName,
      "label": "Sektor",
      "readonly": ""
    }
  }) : _vm.sectorLoading && _vm.selectedSectorName ? _c('v-text-field', {
    attrs: {
      "label": "Sektor",
      "readonly": "",
      "loading": _vm.sectorLoading
    },
    model: {
      value: _vm.selectedSectorName,
      callback: function callback($$v) {
        _vm.selectedSectorName = $$v;
      },
      expression: "selectedSectorName"
    }
  }) : _c('v-select', {
    attrs: {
      "disabled": _vm.isDisabled,
      "label": "Sektor",
      "items": _vm.sectors,
      "item-text": "type",
      "item-value": "id",
      "rules": _vm.validateNotEmpty,
      "loading": _vm.sectorLoading,
      "clearable": ""
    },
    model: {
      value: _vm.applicantData.sectorId,
      callback: function callback($$v) {
        _vm.$set(_vm.applicantData, "sectorId", $$v);
      },
      expression: "applicantData.sectorId"
    }
  })], 1)], 1), _vm.participantComments.length > 0 ? _c('v-row', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('ChatLog', {
    attrs: {
      "comments": _vm.participantComments,
      "currentUserId": _vm.currentUserId,
      "editingGuestUserVisibility": _vm.editingGuestUserVisibility
    },
    on: {
      "updateGuestUserVisibilityCollection": _vm.updateGuestUserVisibilityCollection
    }
  })], 1)], 1) : _vm._e(), _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.commentsLoading ? _c('v-text-field', {
    attrs: {
      "label": "Legg til kommentar",
      "readonly": "",
      "loading": true
    }
  }) : [_c('tiptap-vuetify', {
    attrs: {
      "extensions": _vm.extensions,
      "placeholder": "Legg til kommentar",
      "toolbar-attributes": {
        color: 'grey lighten-4'
      },
      "card-props": {
        outlined: true
      },
      "data-cy": "editParticipantStatusComment"
    },
    model: {
      value: _vm.createdComment.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.createdComment, "comment", $$v);
      },
      expression: "createdComment.comment"
    }
  }), !_vm.hasMemberOrgAccess ? _c('v-switch', {
    attrs: {
      "label": "Synliggjør kommentar for gjestebruker",
      "dense": ""
    },
    model: {
      value: _vm.createdComment.isGuestUserVisible,
      callback: function callback($$v) {
        _vm.$set(_vm.createdComment, "isGuestUserVisible", $$v);
      },
      expression: "createdComment.isGuestUserVisible"
    }
  }) : _vm._e()]], 2)], 1), !_vm.hasMemberOrgAccess ? _c('div', [_c('v-divider'), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    attrs: {
      "value": false,
      "label": "Bruk ".concat(_vm.isVocationalSchool ? 'student' : 'deltaker', " som bestiller og fakturamottaker"),
      "dense": ""
    },
    model: {
      value: _vm.useParticipantAsInvoice,
      callback: function callback($$v) {
        _vm.useParticipantAsInvoice = $$v;
      },
      expression: "useParticipantAsInvoice"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "disabled": _vm.useParticipantAsInvoice,
      "label": "Bestiller og fakturamottaker er like",
      "row": ""
    },
    model: {
      value: _vm.isInvoiceAndPurchaserEqual,
      callback: function callback($$v) {
        _vm.isInvoiceAndPurchaserEqual = $$v;
      },
      expression: "isInvoiceAndPurchaserEqual"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Ja",
      "value": true
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Nei",
      "value": false
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "ml-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('CustomerOrganizationSearchInput', {
    attrs: {
      "existingId": _vm.applicantData.purchaserId || 0,
      "label": _vm.isInvoiceAndPurchaserEqual ? 'Bestiller og fakturamottaker' : 'Bestiller',
      "disable": _vm.useParticipantAsInvoice
    },
    on: {
      "updateId": _vm.updatePurchaserId
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('CustomerOrganizationSearchInput', {
    attrs: {
      "existingId": _vm.applicantData.invoiceRecipientId || 0,
      "label": "Fakturamottaker",
      "disable": _vm.useParticipantAsInvoice || _vm.isInvoiceAndPurchaserEqual
    },
    on: {
      "updateId": _vm.updateInvoiceRecipientId
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }